import Vue from "vue";
import configs from "../configs";
import md5 from "md5";
import querystring from "query-string";

const ip = configs.apiBase;

const retrieve = ({ ativo, limit, offset, value, rows }) => {
  const queryParams = querystring.stringify({
    ativo,
    limit,
    offset,
    value,
    rows,
  });
  return Vue.prototype.$http.get(`${ip}/user?${queryParams}`);
};

const retrieveGrupos = () => {
  return Vue.prototype.$http.get(`${ip}/user/grupos`);
};

const insert = (usuario) => {
  let usr = Object.assign({}, usuario);
  usr.senha = md5(usr.senha);
  return Vue.prototype.$http.post(`${ip}/user`, usr);
};

const update = (usuario) => {
  return Vue.prototype.$http.put(`${ip}/user`, usuario);
};

const changePassword = (usuario) => {
  return Vue.prototype.$http.patch(`${ip}/user`, usuario);
};

const getEmpresasUsuario = (pesquisa) => {
  return Vue.prototype.$http.post(`${ip}/user/empresas`, pesquisa);
};

const ligarEmpresasUsuario = (insert) => {
  return Vue.prototype.$http.patch(`${ip}/user/empresas`, insert);
};

const getMe = async (token) => {
  return Vue.prototype.$http.get(`${ip}/auth/me`);
};

export default {
  retrieve,
  retrieveGrupos,
  insert,
  update,
  changePassword,
  getEmpresasUsuario,
  ligarEmpresasUsuario,
  getMe,
};